import { Box, Button, Text } from 'native-base'

import { colors } from '../../utils/theme/configureTheme'

interface StickySubmitButtonProps {
  onPress: () => void
  isLoading: boolean
  isDisabled: boolean
}

/** Submit button pinned to the bottom of the feedback form. */
export default function StickySubmitButton({ onPress, isLoading, isDisabled }: StickySubmitButtonProps) {
  return (
    <Box
      position="sticky"
      bottom={0}
      left={0}
      right={0}
      px={4}
      py={3}
      backgroundColor={colors.brand.warmWhite}
      borderTopWidth={1}
      borderTopColor={colors.gray[200]}
      zIndex={10}
    >
      <Button
        onPress={onPress}
        isLoading={isLoading}
        isDisabled={isDisabled}
        variant="solid"
        borderRadius={100}
        bgColor={colors.brand.vermillion}
        width="100%"
        py={3}
        _disabled={{
          opacity: 0.5,
        }}
      >
        <Text fontSize={16} fontWeight={600} color={colors.brand.white}>
          Submit
        </Text>
      </Button>
    </Box>
  )
}
